import React from 'react';
import MuiModal, { ModalProps as MuiModalProps } from '@mui/material/Modal';

export type ModalBaseProps = MuiModalProps;

export const ModalBase = React.forwardRef<HTMLDivElement, ModalBaseProps>((props, ref) => {
  return <MuiModal ref={ref} {...props} />;
});

ModalBase.displayName = 'ModalBase';
